<template>
    <div class="datePicker" ref="datePickerContainer">
        <div v-if="label" class="fieldLabel">{{ label }}</div>

        <datepicker
            v-model="internalModel"
            :disabled="disabledDates"
            format="yyyy-MM-dd"
            full-month-name
            calendar-button
            calendar-button-icon="fa fa-calendar"
            monday-first
            :id="id"
        >
        </datepicker>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
    name: 'DatePicker',

    components: {
        Datepicker
    },

    model: {
        prop: 'externalModel'
    },

    props: {
        // nullable `type` needs custom `validator`
        // eslint-disable-next-line vue/require-prop-types
        externalModel: {
            required: true,
            validator: value => value === null || value instanceof Date
        },
        label: {
            type: String,
            default: undefined
        },
        disabledDates: {
            type: Object,
            default: () => {}
        },
        id: {
            type: String,
            default: undefined
        }
    },

    computed: {
        internalModel: {
            get() {
                return this.externalModel;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    }
};
</script>

<style lang="scss">
@import '../assets/styles/settings';
@import '../assets/styles/components/button';

.datePicker {
    .fieldLabel {
        font-weight: bold;
        margin-bottom: 5px;
    }

    .vdp-datepicker {
        > div:first-child {
            display: flex;
            flex-direction: row-reverse;

            input[type='text'] {
                width: 100%;
                padding: 6px 12px;
                font-size: 14px;
                font-family: inherit;
                border: 1px solid $color_gray_very_light;
                border-right-width: 0;
                color: $color_gray_nero;
                background-color: $color_white;
                box-shadow: inset 0 1px 1px transparentBlack(0.075);
                border-bottom-left-radius: 4px;
                border-top-left-radius: 4px;
            }
        }

        .vdp-datepicker__calendar {
            border-radius: 4px;
            box-shadow: 0 6px 12px transparentBlack(0.175);

            .cell {
                border-radius: 4px;

                &.day-header {
                    font-weight: bold;
                }

                &:not(.day-header):not(.blank):not(.disabled):hover {
                    border-color: $color_ci_blue_shade1;
                }

                &.selected {
                    background: $color_ci_blue_shade1;
                    color: $color_white;
                    font-weight: bold;
                    box-shadow: inset 0 3px 5px transparentBlack(0.125);
                }
            }
        }

        .vdp-datepicker__calendar-button {
            @include button();

            border-bottom-left-radius: 0;
            border-top-left-radius: 0;
        }
    }
}
</style>
